import {
  IonButton as IonicIonButton,
  IonSpinner as IonicIonSpinner,
} from '@ionic/react'
import { styled } from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { Size, Variant } from './Button'

export const IonButton = styled(IonicIonButton)<{
  $variant: Variant
  $fullWidth?: boolean
  $uppercase?: boolean
}>`
  margin: 0;
  font-size: 16px;
  min-height: auto;
  font-weight: 500;
  opacity: 1;
  position: relative;

  --padding-top: 0px;
  --padding-bottom: 0px;
  --padding-right: 0px;
  --padding-left: 0px;
  --color: ${myPalette.midnightBlue.main};
  --border-radius: 8px;
  border-radius: 8px;

  text-transform: ${({ $uppercase }) => ($uppercase ? 'uppercase' : 'none')};

  ${({ $fullWidth }) => {
    if ($fullWidth) {
      return {
        width: '100%',
      }
    }
  }}

  &[aria-disabled='true']::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: rgba(255, 255, 255, 0.4);
  }

  &::part(native) {
    padding: 0;
  }

  ${({ $variant }) => {
    if ($variant === 'limeFlooded') {
      return {
        '--background': myPalette.limeGreen.main,
        '--background-activated': myPalette.limeGreen['600'],
        '--background-hover': myPalette.limeGreen['600'],
      }
    }
    if ($variant === 'coralFlooded') {
      return {
        '--color': myPalette.white.main,
        '--background': myPalette.coral.main,
        '--background-activated': myPalette.coral['600'],
        '--background-hover': myPalette.coral['600'],
      }
    }
    if ($variant === 'lightSteelBlueBorder') {
      return {
        '--color': myPalette.midnightBlue.main,
        '--background': myPalette.white.main,
        '--background-activated': myPalette.white['100'],
        '--background-hover': myPalette.white['100'],
        '--border-color': myPalette.blue.lightSteelBlue,
        '--border-style': 'solid',
        '--border-width': '1px',
      }
    }
    if ($variant === 'textLink') {
      return {
        '--color': myPalette.blue['600'],
        '--background': 'transparent',
        '--background-activated': 'transparent',
        '--background-hover': 'transparent',
      }
    }
    if ($variant === 'whiteFlooded') {
      return {
        '--background': myPalette.white.main,
        '--background-activated': myPalette.white['100'],
        '--background-hover': myPalette.white['100'],
        boxShadow: `0 0 5px ${myPalette.dark.shadowLight}`,
      }
    }
    if ($variant === 'blueFlooded') {
      return {
        '--color': myPalette.white.main,
        '--background': myPalette.blue.main,
        '--background-activated': myPalette.blue['600'],
        '--background-hover': myPalette.blue['600'],
      }
    }
    if ($variant === 'aliceBlueFlooded') {
      return {
        '--color': myPalette.midnightBlue.main,
        '--background': myPalette.aliceBlue.main,
        '--background-activated': myPalette.aliceBlue['100'],
        '--background-hover': myPalette.aliceBlue['100'],
      }
    }
    if ($variant === 'contained') {
      return {
        '--color': myPalette.white['100'],
        '--background': myPalette.orange['100'],
        '--background-hover': myPalette.orange.orangeHover,
        '--border-radius': '4px',
        '--padding': '4px 10px',
      }
    }
  }}
`

export const ButtonContent = styled.div<{
  $size?: Size
}>`
  padding: 14px 24px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $size }) => {
    if ($size === 'large') {
      return {
        padding: '20px 24px',
      }
    }
  }}
`

export const EndDecoratorWrapper = styled.div`
  margin-left: 4px;
  display: flex;
`

export const StartDecoratorWrapper = styled.div`
  margin-right: 4px;
  display: flex;
`

export const IonSpinner = styled(IonicIonSpinner)`
  width: 16px;
  height: 16px;
`
